(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["navigation-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const menuButton = event.target.closest('[data-mobile-widget]');
  if (!menuButton || menuButton.getAttribute('aria-busy') === 'true') return;

  const widget = menuButton.dataset.mobileWidget;
  const widgetSelectors = {
    keycrm: '.KeyCRM-toggleButton[aria-label="Open chat widget"]',
    ringostat: '#Widget [role="button"]',
  };
  const widgetLoaders = {
    keycrm: () => window.loadKeyCRM?.(),
    ringostat: () => window.loadRingostat?.(),
  };
  const drawer = menuButton.closest('header-drawer');
  const drawerSummary = drawer ? drawer.querySelector('summary') : null;

  menuButton.setAttribute('aria-busy', 'true');
  menuButton.disabled = true;
  widgetLoaders[widget]?.();

  const finishLoading = () => {
    menuButton.removeAttribute('aria-busy');
    menuButton.disabled = false;
  };

  const openWidget = (attempt = 0) => {
    const trigger = document.querySelector(widgetSelectors[widget]);
    if (trigger) {
      finishLoading();
      if (drawerSummary) drawerSummary.click();
      window.setTimeout(() => trigger.click(), 200);
      return;
    }

    if (attempt < 80) {
      window.setTimeout(() => openWidget(attempt + 1), 100);
    } else {
      finishLoading();
    }
  };

  openWidget();
});
  } catch(e) { console.error(e); }
})();

})();
